var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"microsoft-cv"},[_c('Tools02Contents',{attrs:{"productId":_vm.mainProductId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }